import React from "react"

export default function WatermarkSection({ children, size = 280 }) {
  return (
    <section className="relative overflow-hidden rounded-3xl border shadow-sm bg-white">
      <div
        className="absolute inset-0 opacity-10 pointer-events-none select-none"
        style={{
          backgroundImage: "url(/logo.png)",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center", // Cambiado a centrado
          backgroundSize: `${size}px`,
        }}
      />
      <div className="relative p-6 md:p-8">{children}</div>
    </section>
  )
}
